var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("basic-container", [
        _c("div", { staticClass: "banner-text" }, [
          _c("span", [
            _c(
              "a",
              { attrs: { href: "https://avue.top/#/pay", target: "_blank" } },
              [
                _c("img", {
                  attrs: {
                    src: "https://img.shields.io/badge/Avue-2.9.14-green.svg",
                    alt: "Build Status",
                  },
                }),
              ]
            ),
            _c("img", {
              attrs: {
                src: "https://img.shields.io/badge/Spring%20Boot-2.7.7-yellowgreen.svg",
                alt: "Downloads",
              },
            }),
            _c("img", {
              attrs: {
                src: "https://img.shields.io/badge/Spring%20Cloud-2021-blue.svg",
                alt: "Coverage Status",
              },
            }),
          ]),
          _c("br"),
          _c(
            "span",
            [
              _c(
                "el-collapse",
                {
                  model: {
                    value: _vm.activeNames,
                    callback: function ($$v) {
                      _vm.activeNames = $$v
                    },
                    expression: "activeNames",
                  },
                },
                [
                  _c("el-collapse-item", { attrs: { name: "1" } }, [
                    _c("div", [_vm._v("基于Spring Cloud Gateway")]),
                    _c("div", [_vm._v("基于Spring Cloud 2021")]),
                    _c("div", [_vm._v("基于Spring Boot 2.7")]),
                    _c("div", [_vm._v("基于Spring Cloud Alibaba 2021")]),
                  ]),
                  _c("el-collapse-item", { attrs: { name: "2" } }, [
                    _c("div", [
                      _vm._v("基于Spring Security OAuth实现鉴权体系；"),
                    ]),
                    _c("div", [
                      _vm._v("深度定制，支持全流程的登录授权，Server Resource"),
                    ]),
                  ]),
                  _c("el-collapse-item", { attrs: { name: "3" } }, [
                    _c("div", [_vm._v("支持docker部署")]),
                    _c("div", [_vm._v("支持Rancher2 + Kubernetes部署")]),
                    _c("div", [_vm._v("支持企业Paas Rainbond 部署")]),
                  ]),
                  _c("el-collapse-item", { attrs: { name: "4" } }, [
                    _c("div", [
                      _vm._v("基于开源LCN + Seata 分布式事务解决方案深度定制"),
                    ]),
                    _c("div", [_vm._v("完美兼容2.X，优化集群部署，提升性能")]),
                  ]),
                  _c("el-collapse-item", { attrs: { name: "5" } }, [
                    _c("div", [_vm._v("扩展Spring Cache无缝兼容")]),
                    _c("div", [_vm._v("支持开发过程无感知")]),
                  ]),
                  _c("el-collapse-item", { attrs: { name: "6" } }, [
                    _c("div", [_vm._v("基于activiti5.22整合OAuth2")]),
                    _c("div", [_vm._v("支持在线流程设计")]),
                  ]),
                  _c("el-collapse-item", { attrs: { name: "7" } }, [
                    _c("div", [_vm._v("支持数据库存储SCG路由信息")]),
                    _c("div", [_vm._v("支持前端动态编辑")]),
                  ]),
                  _c("el-collapse-item", { attrs: { name: "8" } }, [
                    _c("div", [_vm._v("单点登录")]),
                    _c("div", [_vm._v("扩展SBA支持服务监听事件redis保存")]),
                    _c("div", [_vm._v("扩展Turbine,定制展示UI")]),
                    _c("div", [
                      _vm._v("扩展ResourceServer完全屏蔽实现细节开发更简单"),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }